// extracted by mini-css-extract-plugin
export default {"modalBtn":"style_modalBtn__0VuKs","modalImage":"style_modalImage__tXCjs","discardBtn":"style_discardBtn__PWZfW"};